import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import {
  Row,
  Col,
  DropdownButton,
  Dropdown,
  Spinner,
  Button,
} from "react-bootstrap";

import _ from "lodash";
import { AiFillFileExcel } from "react-icons/ai";
import Swal from "sweetalert2";
import { format } from "date-fns";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import SearchService from "app/services/SearchService";
import {
  approveReq,
  declineReq,
  getrequisitionForEdit,
  reactiveReq,
} from "app/services/paymentService";
import moment from "moment";
import { MdDone, MdClear, MdVpnKey, MdSearch, MdRefresh } from "react-icons/md";
// import EditReq from "./EditReq";
import config from "config.json";
import {
  getrequisition,
  // approveReq,
  // declineReq,
  // getrequisitionForEdit,
  exportRequisition,
  // reactiveReq,
} from "app/services/requisitionService";
import queryStringService from "app/services/queryStringService";

const { dateTimeFormat, apiUrl, dateFormat } = config;

const AllReq = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [memId, setMemId] = useState(0);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [status, setStatus] = useState("Pending");
  const [ReqId, setReqId] = useState(0);
  const [showEditReq, setShowEditReq] = useState(false);
  const [RequisitionType, setRequisitionType] = useState("");

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "FromDate":
        setFromDate(value);
        break;
      case "ToDate":
        setToDate(value);
        break;
      // Add cases for other fields...
      case "status":
        setStatus(value);
        break;
      case "RequisitionType":
        setRequisitionType(value);
        break;

      default:
        break;
    }
  };

  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹{row.amount} </span>;
  };

  const transactionModeFormatter = (cell, row) => {
    return <span>{row.transferMethod?.toUpperCase()} </span>;
  };

  const dateFormater = (cell, row) => {
    if (cell) {
      return (
        new moment(cell).format(dateFormat) +
        "  " +
        moment(row.systemDate).format("HH:mm:ss")
      );
    }
  };

  const statusColor = (cell, row) => {
    if (row.status === "Declined") {
      return <span className="text-danger">Declined</span>;
    }
    if (row.status === "Pending") {
      return <span className="text-primary">Pending</span>;
    }
    if (row.status === "Approved") {
      return <span className="text-success">Approved</span>;
    }
  };

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransaction = async () => {
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      status,
      RequisitionType,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    try {
      const response = await getrequisition(query);
      const responseData = response.data;

      const paggingData = JSON.parse(response.headers["x-pagination"]);

      setData(responseData.data);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
    } catch (error) {
      console.error("Error loading transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTransaction();
  }, []);

  const columns = [
    {
      dataField: "fromMember.uniqueIdentity",
      text: "Username",

      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionId",
      text: "Transaction Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "requestDate",
      text: "Req Date",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "approveDate",
      text: "Approval Date",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "pgType",
      text: "Req Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transferMethod",
      text: "Payment Mode",
      formatter: transactionModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "referenceNo",
      text: "Ref. Number",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "bankName",
      text: "Bank",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: statusColor,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "remark",
      text: "Remark",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: transactionAmountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
  ];
  const refreshFilter = async () => {
    setFromDate("");
    setToDate("");
    setStatus("");
    setRequisitionType("");

    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);

    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const exportAllReq = async () => {
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      status,

      RequisitionType,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    try {
      const response = await exportRequisition(query);
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${moment().toISOString()}_requisition.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>All Requisition</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "All Requisition" }]}></Breadcrumb>

      <div className="card card-body rounded border mb-2">
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label> Transaction Status</label>
            </div>
            <select
              className="form-control"
              placeholder="Transaction Status"
              name="status"
              value={status}
              onChange={handleSearchChanges}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approve</option>
              <option value="Declined">Decline</option>
            </select>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Transaction Mode</label>
            </div>
            <select
              className="form-control"
              placeholder="Transaction Type"
              name="RequisitionType"
              value={RequisitionType}
              onChange={handleSearchChanges}
            >
              <option value="">All</option>
              <option value="CREDIT">Credit</option>
              <option value="NORMAL">Normal</option>
            </select>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="FromDate"
              // placeholder="Date From"
              value={FromDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="ToDate"
              //  placeholder="Date To"
              value={ToDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>

          <div
            className="col d-flex justify-content-around"
            style={{ marginTop: "3%" }}
          >
            <button className="btn btn-outline-primary" onClick={handleSearch}>
              <MdSearch className="mx-2" size={18} />
            </button>
            <button className="btn btn-primary mx-1" onClick={refreshFilter}>
              Refresh
            </button>

            <Button
              variant="outline-primary"
              // className="ml-2"
              onClick={handleExport}
            >
              Export Excel
              <AiFillFileExcel className=" ml-2" />
            </Button>
          </div>
        </div>
      </div>

      <div className="mb-3">
        <BootstrapTable
          hover
          remote
          keyField="uniqueIdentity"
          data={data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          loading={loading}
          overlay={overlayFactory({
            spinner: true,
            styles: {
              overlay: (base) => ({
                ...base,
                background: "rgba(120, 120, 120, 0.5)",
                zIndex: "1",
              }),
            },
          })}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
    </>
  );
};

export default AllReq;
